
<script lang="ts">
  import { type StoresKey } from "~/stores";
  import MapApp from "../MapApp.svelte";
  import VisioMapLayer from "./VisioMapLayer.svelte";
  import { VisioMapApp, type VisioMapAppConfig } from "./visiomap";
  import { createEventDispatcher } from "svelte";
  import { type ConnectMapEvent } from "../app";

  export let request_store_key: StoresKey;
  export let config: VisioMapAppConfig;

  let dispatch = createEventDispatcher<ConnectMapEvent>()
  const app = new VisioMapApp(config);
  
</script>

<MapApp {app} {request_store_key} map_layer={VisioMapLayer} on:*>
  <!-- {#if BROWSER}
    <VisioMapLayer on:tap_poi={(e) => {console.log('mlayer', e)}} />
  {/if} -->
</MapApp>
